/**
 * User: Faris
 * Date: 5/24/13
 * Time: 3:24 PM
 */

require(['./config'], function(){

  require(['./libs'], function() {

    //cache bust for app code
    requirejs.config({ urlArgs: 'v=' + new Date().getTime() });

    require(['./app/site'], function(Site){

      //parsley config
      window.ParsleyConfig = (window.ParsleyConfig || {});
      window.ParsleyConfig.errors = {
        container: function (element, isRadioOrCheckbox) {
          return null;
        }
      };
      
      // Detect browsers
      var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
      var isFirefox = typeof InstallTrigger !== 'undefined';   // Firefox 1.0+
      var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
      // At least Safari 3+: "[object HTMLElementConstructor]"
      var isChrome = !!window.chrome && !isOpera;              // Chrome 1+
      var isIE = /*@cc_on!@*/false || !!document.documentMode; // At least IE6
      var browsers = new Array();
      browsers['opera'] = isOpera;
      browsers['firefox'] = isFirefox;
      browsers['safari'] = isSafari;
      browsers['chrome'] = isChrome;
      browsers['msie'] = isIE;
      
      for(var key in browsers) {
          if(browsers[key] && !$('html').hasClass(key)) {
              $('html').addClass(key);
              if(key=='msie') {
                  var myNav = navigator.userAgent.toLowerCase();
                  var version = (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
                  $('html').addClass('msie'+version);
              }
          }
      }

      //store site var in global scope
      window.s = new Site();
      window.s.start();
    });

  });

});
define("main", function(){});

